module.exports = __webpack_public_path__ + "img/icon_add.0248b8e2.png";